import { render } from "./Defect.vue?vue&type=template&id=2139aac4"
import script from "./Defect.vue?vue&type=script&lang=js"
export * from "./Defect.vue?vue&type=script&lang=js"

import "./Defect.vue?vue&type=style&index=0&id=2139aac4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__